/**
 * Zentrale Konfiguration für Service-Preise
 * 
 * Diese Datei enthält alle Preise für zusätzliche Services wie Montage, Aufmaß und technische Zeichnungen.
 * Alle Preise sind in Euro (netto) angegeben.
 */

// Service-Preise Konfiguration
export const SERVICE_CONFIG = {
  installation: {
    name: 'Montage durch GlasoLux',
    price: 1500,
    description: 'Professionelle Montage vor Ort',
    mwstRate: 0.19
  },
  measurement: {
    name: 'Aufmaß durch GlasoLux', 
    price: 500,
    description: 'Präzise Vermessung vor Ort',
    mwstRate: 0.19
  },
  technicalDrawing: {
    name: 'Technische Zeichnung',
    price: 900,
    description: 'Detaillierte technische Pläne',
    mwstRate: 0.19
  }
};

// Konstanten für einfachen Zugriff
export const SERVICE_PRICES = {
  installation: SERVICE_CONFIG.installation.price,
  measurement: SERVICE_CONFIG.measurement.price,
  technicalDrawing: SERVICE_CONFIG.technicalDrawing.price
};

// MwSt-Satz (19%)
export const MWST_RATE = 0.19;

// RAL-Farben Aufpreis (pro Farbe: außen oder innen)
export const RAL_SURCHARGE = 95;

// Helper-Funktionen
export const calculateServicePrice = (serviceType: keyof typeof SERVICE_CONFIG, includeMwst: boolean = false) => {
  const service = SERVICE_CONFIG[serviceType];
  const netPrice = service.price;
  
  if (includeMwst) {
    return netPrice + (netPrice * service.mwstRate);
  }
  
  return netPrice;
};

export const calculateTotalServicePrice = (
  services: { installation?: boolean; measurement?: boolean; technicalDrawing?: boolean },
  includeMwst: boolean = false
) => {
  let total = 0;
  
  if (services.installation) {
    total += calculateServicePrice('installation', includeMwst);
  }
  
  if (services.measurement) {
    total += calculateServicePrice('measurement', includeMwst);
  }
  
  if (services.technicalDrawing) {
    total += calculateServicePrice('technicalDrawing', includeMwst);
  }
  
  return total;
};

export const getServiceDetails = (serviceType: keyof typeof SERVICE_CONFIG) => {
  return SERVICE_CONFIG[serviceType];
};

// Für zukünftige Erweiterungen
export const updateServicePrice = (serviceType: keyof typeof SERVICE_CONFIG, newPrice: number) => {
  console.warn(`Service-Preis Update: ${serviceType} von ${SERVICE_CONFIG[serviceType].price}€ auf ${newPrice}€`);
  SERVICE_CONFIG[serviceType].price = newPrice;
  // Update auch das SERVICE_PRICES Objekt
  (SERVICE_PRICES as any)[serviceType] = newPrice;
};

export default SERVICE_CONFIG;
